import { Image } from "antd";

const LDImage = (props) => {
    return <Image {...props} preview={false} />
}

export default LDImage